module.exports = __webpack_public_path__ + "static/media/ReceiveVoucherKK.f2879f33.pdf";